import React, { useState, useEffect } from 'react';
import { LegacyTiersProvider } from '../contexts/legacyTiers-context';
import { PageGrid, PageContainer, PageErrorRedirector, PageProviders, } from '../components/shared/page-layout';
import { ERR_GENERIC, B2B_ANALYTICS, B2B_BREADCRUMBS } from '../constants';
import { windowExists } from '../components/Utils';
import { setAnalytics } from '../utils/analytics';
import Spinner from '../components/shared/spinner/spinner';
import { PerksPageContainer } from '../containers/PerksPage/PerksPageContainer';
import { InfoPerksContext } from '../contexts';
import { Error } from './Error';
var RenderPage = function (_a) {
    var customerType = _a.customerType, customerRole = _a.customerRole;
    var _b = useState(null), generalError = _b[0], setGeneralError = _b[1];
    var _c = React.useContext(InfoPerksContext), perksInfo = _c.perksInfo, isLoading = _c.isLoading, setIsLoading = _c.setIsLoading, getPerksInfoPerksData = _c.getPerksInfoPerksData;
    var breadcrumbs = B2B_BREADCRUMBS.proXtraPerks;
    useEffect(function () {
        var apiController = new AbortController();
        setIsLoading(true);
        getPerksInfoPerksData({ signal: apiController.signal })
            .then(function () {
            setIsLoading(false);
        })
            .catch(function () {
            setIsLoading(false);
            setGeneralError(ERR_GENERIC);
        });
        if (windowExists() && (window === null || window === void 0 ? void 0 : window.digitalData)) {
            window.digitalData.page = B2B_ANALYTICS.proXtraPerks;
            setAnalytics(window.digitalData);
        }
        return function () {
            apiController.abort();
        };
    }, []);
    var RenderNewPerksPage = function () { return (React.createElement(PageGrid, null,
        React.createElement(Spinner, { active: isLoading }),
        React.createElement(LegacyTiersProvider, { rewardsAndOffers: null }, customerRole === 'PURCHASER' ? (React.createElement(Error, null)) : (React.createElement(PageContainer, { title: "Pro Xtra Perks", breadcrumbs: breadcrumbs, internalRoutes: ['/myaccount/proXtraPerks'], generalError: generalError, classes: {
                contentContainer: 'proXtraPerks_page',
            } },
            React.createElement(PerksPageContainer, null)))))); };
    return React.createElement(RenderNewPerksPage, null);
};
export var PerksPage = function (_a) {
    var customerType = _a.customerType, customerRole = _a.customerRole;
    return (React.createElement(PageErrorRedirector, null,
        React.createElement(PageProviders, { page: "PerksPage" },
            React.createElement(RenderPage, { customerType: customerType, customerRole: customerRole }))));
};
PerksPage.displayName = 'PerksPage';
